import { Box, Typography } from '@mui/material';
import FailedIcon from "assets/svgs/onrampfailed.svg";
import { InsideDrawer } from 'components/shared/Drawer/InsideDrawer';
import MHeading from 'components/shared/MHeading';
import { useOnrampContext } from 'context/OnRamp';
import React from 'react';


type InvalidNetworkBottomSheetProps = {
    showDrawer: boolean;
};

const InvalidNetworkBS: React.FC<InvalidNetworkBottomSheetProps> = (
    { showDrawer }

    ) => {
    const {  withdrawNetworkState } = useOnrampContext()

    const selectedNetwork = withdrawNetworkState.selectedNetwork?.value?.name
    const alternate = withdrawNetworkState.cryptoNetworks?.[0]
    

    return (
        <InsideDrawer
            anchor={"bottom"}
            open={showDrawer}
            onClose={() => { }}
            PaperProps={{
                square: false,
                sx: {
                    height: 'calc(40%)',
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                },
            }}
        >
            <Box
                component="section"
            >
                <Box
                    sx={{
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'white',
                        padding: '16px',
                        // borderBottom: '1px solid #E0E0E0',
                        zIndex: 1,
                    }}
                >
                    <MHeading heading={"Invalid Network"} subHeading={undefined} />
                    {/*@ts-ignore */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '16px',
                        }}>
                        <img style={{ height: 60 }} src={FailedIcon} /></Box>
                        <Typography sx={{ paddingLeft: 2, paddingRight: 2 }}>Payments are currently not accepted on the {selectedNetwork} network. Please use {alternate?.name}.</Typography>
                </Box>
            </Box>
        </InsideDrawer>
    );
};

export default InvalidNetworkBS;